@if (matIconButton() === true && matStrokedButton() === false) {
  <button [matTooltip]="tooltip()" [ngClass]="{'small-button': small() !== false}" mat-icon-button="" [color]="color()" [disabled]="loading() || disabled()" [class.is-loading]="loading()" (click)="buttonClick.emit()" class="flex-1">
    @if (icon() && matIconPosition() === 'prefix') {
      <mat-icon class="not-loading">{{icon()}}</mat-icon>
    }
    @if (loading()) {
      <span class="loading">
        <mat-spinner diameter="24"></mat-spinner>
      </span>
    }
    @if (icon() && matIconPosition() === 'suffix') {
      <mat-icon class="not-loading">{{icon()}}</mat-icon>
    }
  </button>
}
@if (matStrokedButton() === true && matIconButton() === false) {
  <button [matTooltip]="tooltip()" [ngClass]="{'small-button': small() !== false}" mat-stroked-button="" [color]="color()" [disabled]="loading() || disabled()" [class.is-loading]="loading()" (click)="buttonClick.emit()" class="flex-1">
    @if (icon() && matIconPosition() === 'prefix') {
      <mat-icon class="not-loading" [class.mr1]="text() && text() !== ''">{{icon()}}</mat-icon>
    }
    @if (text() && text() !== '') {
      <span class="not-loading">{{text()}}</span>
    }
    @if (loading()) {
      <span class="loading">
        <mat-spinner diameter="24"></mat-spinner>
      </span>
    }
    @if (icon() && matIconPosition() === 'suffix') {
      <mat-icon class="not-loading" [class.ml1]="text() && text() !== ''">{{icon()}}</mat-icon>
    }
  </button>
}
@if (matStrokedButton() === false && matIconButton() === false) {
  <button [matTooltip]="tooltip()" [ngClass]="{'small-button': small() !== false}" mat-flat-button="" [color]="color()" [disabled]="loading() || disabled()" [class.is-loading]="loading()" (click)="buttonClick.emit()" class="flex-1">
    @if (icon() && matIconPosition() === 'prefix') {
      <mat-icon class="not-loading" [class.mr1]="text() && text() !== ''">{{icon()}}</mat-icon>
    }
    @if (text() && text() !== '') {
      <span class="not-loading">{{text()}}</span>
    }
    @if (loading()) {
      <span class="loading">
        <mat-spinner diameter="24"></mat-spinner>
      </span>
    }
    @if (icon() && matIconPosition() === 'suffix') {
      <mat-icon class="not-loading" [class.ml1]="text() && text() !== ''">{{icon()}}</mat-icon>
    }
  </button>
}
